// Customizable Area Start
import moment from "moment"
import { getStorageData } from "../../framework//src/Utilities"
import { IncomingMessage } from "../../blocks/chat/src/ChatController"
const configJSON = require("./config.js")

export const scrollToTop = (isInstant?: boolean) => {
  const headerElement = document.querySelector(".navContainer")
  if (headerElement) {
    headerElement.scrollIntoView({ behavior: isInstant ? "auto" : "smooth" })
  }
}

export const formatCurrency = (price: string | number, spaceBetween = true) =>
  `\u20B9${spaceBetween ? " " : ""}${price}`

export const isAuthenticated = async (redirectFunc: (path: string) => void) => {
  const token = await getStorageData(configJSON.TOKEN)
  if (!token) {
    redirectFunc(configJSON.LOGIN_PATH)
    return false
  }

  return true
}

export const formatChatTime = (sentAt: number): string => {
  const time = moment.unix(sentAt)
  if (time.isSame(moment(), "day")) return time.format("hh:mm A")
  if (time.isSame(moment().subtract(1, "day"), "day")) return "Yesterday"
  if (time.isAfter(moment().startOf("week"))) return time.format("dddd")
  return time.format("DD.MM.YYYY")
}

export const getLastMessagePreview = (message: IncomingMessage): string => {
  switch (message.category) {
    case "message":
      if (message.type === "text") {
        return message.data.text
      }

      if (["image", "video", "audio", "file"].includes(message.type)) {
        return "Attachment"
      }

      return "Unsupported message"

    default:
      return "Unknown message type"
  }
}

export const formatCallTimer = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return [
    hours.toString().padStart(2, "0"),
    minutes.toString().padStart(2, "0"),
    seconds.toString().padStart(2, "0"),
  ].join(":")
}

export function capitalizeFirstLetter(text: string): string {
  if (!text) return ""
  return text.charAt(0).toUpperCase() + text.slice(1)
}
// Customizable Area End
